import React from "react";

const Footer = () => {
  return (
    <>
    <div className="container">
  <footer className="bg-info text-black py-3 shadow-sm">
    <div className="container">
      <div className="row align-items-center">

        <div className="col-md-6 text-center text-md-start">
          <small>
            {/* © {new Date().getFullYear()} MIS & ICT Division, BSEC */}
          </small>
        </div>

        <div className="col-md-6 text-center text-md-end">
          <small>
            Design & Developed by MIS & ICT Division, BSEC
          </small>
        </div>

      </div>
    </div>
  </footer>
</div>
    </>
  );
};

export default Footer;